import React from 'react';
import { ExclusivityBadge } from './briefs/BriefCreatorList';

const fmt = (n) => (n == null ? '—' : n >= 1e6 ? `${(n / 1e6).toFixed(1)}M` : n >= 1e3 ? `${(n / 1e3).toFixed(1)}K` : n);
const inr = (n) => (n ? `₹${Number(n).toLocaleString('en-IN')}` : '—');
const TH = 'px-3 py-2 text-left text-[10px] font-semibold uppercase tracking-wider text-[#6B6B6B] dark:text-zinc-400 whitespace-nowrap';
const TD = 'px-3 py-2 text-xs text-[#0F0F0F] dark:text-white align-top';
const CELL_INPUT = 'rounded-md px-2 py-1 text-xs bg-white dark:bg-[#1A1D24] border border-black/[0.12] dark:border-white/[0.08] text-[#0F0F0F] dark:text-white placeholder-[#A1A1AA] dark:placeholder-zinc-500';

const Row = ({ c, i, onChange, costCols }) => (
  <tr className={`border-t border-black/[0.06] dark:border-white/5 ${c.selected ? '' : 'opacity-45'}`} data-testid={`ideation-row-${c.creator_id}`}>
    <td className={TD}>
      <input type="checkbox" checked={c.selected} onChange={(e) => onChange({ selected: e.target.checked })} className="accent-[#FF451A]" data-testid={`ideation-select-${c.creator_id}`} />
    </td>
    <td className={TD}><span className="font-mono">{i + 1}</span> · <span className="font-semibold">P{c.pitch_priority}</span><div className="mt-0.5" data-testid={`ideation-excl-${c.creator_id}`}><ExclusivityBadge label={c.priority_label} /></div></td>
    <td className={`${TD} font-semibold`}>{c.name}</td>
    <td className={TD}>{c.instagram_handle ? <a href={c.instagram_link} target="_blank" rel="noopener noreferrer" className="text-[#FF451A] hover:underline">@{c.instagram_handle}</a> : '—'}</td>
    <td className={`${TD} font-mono`}>{fmt(c.instagram_followers)}</td>
    <td className={TD}>{c.quality_tier || '—'}</td>
    <td className={`${TD} max-w-[180px] truncate`} title={c.category}>{c.category || '—'}</td>
    <td className={TD}>{c.city || '—'}</td>
    <td className={`${TD} font-mono`}>{fmt(c.instagram_avg_views)}</td>
    <td className={`${TD} font-mono`}>{c.instagram_engagement_rate != null ? `${c.instagram_engagement_rate}%` : '—'}</td>
    {costCols.map((col) => <td key={col.key} className={`${TD} font-mono`} data-testid={`ideation-cost-${col.key}-${c.creator_id}`}>{inr(c[col.key])}</td>)}
    <td className={TD}>
      <input type="number" step="0.1" min={0} max={10} value={c.fit_score} onChange={(e) => onChange({ fit_score: e.target.value === '' ? '' : Number(e.target.value) })} className={`${CELL_INPUT} w-16`} data-testid={`ideation-fit-${c.creator_id}`} />
    </td>
    <td className={`${TD} min-w-[260px] text-[11px] text-[#4B5563] dark:text-zinc-300`}>{c.fit_notes}</td>
    <td className={TD}>
      <input value={c.manager_note || ''} onChange={(e) => onChange({ manager_note: e.target.value })} placeholder="Add note" className={`${CELL_INPUT} w-44`} data-testid={`ideation-note-${c.creator_id}`} />
    </td>
  </tr>
);

export const ShortlistTable = ({ rows, onRowChange, costCols }) => (
  <div className="overflow-x-auto border border-black/[0.08] dark:border-white/5 rounded-2xl bg-white dark:bg-[#0F1115]" data-testid="ideation-results-table">
    <table className="w-full">
      <thead className="bg-black/[0.02] dark:bg-white/[0.02]">
        <tr>
          {['', 'Rank', 'Creator', 'IG Handle', 'Followers', 'Quality', 'Category', 'City', 'Avg Views', 'ER%', ...costCols.map((c) => c.label), 'Fit', 'Fit Notes', 'Manager Note'].map((h) => <th key={h} className={TH} data-testid={`ideation-th-${h.toLowerCase().replace(/[^a-z0-9]+/g, '-') || 'select'}`}>{h}</th>)}
        </tr>
      </thead>
      <tbody>
        {rows.map((c, i) => <Row key={c.creator_id} c={c} i={i} onChange={(patch) => onRowChange(c.creator_id, patch)} costCols={costCols} />)}
      </tbody>
    </table>
  </div>
);
